import { PreflightCopy } from '@signalvote/shared';
import type { ReportRowInclusion } from '@signalvote/shared';

/**
 * The "Already reported" pill for a schedule row folded back into an open report's display:
 * its per-row ledger status flipped to Reported by a state upload before the period
 * was filed/closed. Marked so the treasurer can tell it apart from the not-yet-uploaded rows
 * that will be on the next filing (which carry no badge).
 *
 * Shared by the contribution + expenditure rows in both the flat and Alabama schedules. It
 * self-gates on inclusion (renders nothing unless Reported) so each call site is one
 * guard-free line; `testId` distinguishes the four sites (al-/flat × contribution/expenditure).
 */
export function ReportedRowBadge({
  inclusion,
  testId,
}: {
  inclusion: ReportRowInclusion;
  testId: string;
}) {
  if (inclusion !== 'Reported') return null;
  return (
    <span
      data-testid={testId}
      className="rounded-full bg-emerald-100 px-1.5 py-0.5 text-xs font-medium text-emerald-800"
    >
      {PreflightCopy.ScheduleReportedRowLabel}
    </span>
  );
}
